import React, { useState } from "react";
import Wrapper from "../Components/Wrapper";
import Herosection from "../Components/Herosection";
import { Col, Container, Form, Row } from "react-bootstrap";
import toast from "react-hot-toast";

function ContactUs() {
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    formFName: "",
    formLName: "",
    formBasicEmail: "",
    formMessage: "",
  });

  function chnagehandler(event) {
    setFormData((prevdata) => ({
      ...prevdata,
      [event.target.name]: event.target.value,
    }));
  }

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      toast.error("Complete All Fields");
    } else {
      toast.success("Message Submitted Sucessfully");
      setValidated(true);
    }
  };
  return (
    <div>
      <Wrapper id={"contactwrapper"}>
        <Herosection title={"Contact"} />
        <Container className="py-5">
          <Row>
            <Col lg={6} data-aos="fade-right">
              <div className="h-100">
                <iframe
                  title="map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224357.50123760625!2d77.23701401139074!3d28.522102350643507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5a43173357b%3A0x37ffce30c87cc03f!2sNoida%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1711531600625!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: "0" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </Col>
            <Col lg={6} data-aos="fade-left">
              <div className="contact-form rounded-4 p-sm-5 p-3">
                <p className="red-para fw-bold">Our Contact</p>
                <h3 className="fw-bold mb-4">Get in Touch</h3>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  <div>
                    <Row>
                      <Col sm={6}>
                        <Form.Group className="mb-3" controlId="formName">
                          <Form.Control
                            type="text"
                            placeholder="Name"
                            className="py-2"
                            name="formName"
                            value={formData.formFName}
                            onChange={chnagehandler}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm={6}>
                        <Form.Group className="mb-3" controlId="formName">
                          <Form.Control
                            type="text"
                            placeholder="Last Name"
                            className="py-2"
                            name="formName"
                            value={formData.formLName}
                            onChange={chnagehandler}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Control
                            required
                            type="email"
                            placeholder="Enter email"
                            className="py-2"
                            name="formBasicEmail"
                            value={formData.formBasicEmail}
                            onChange={chnagehandler}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <Form.Group className="mb-3" controlId="formMessage">
                      <Form.Control
                        required
                        as="textarea"
                        rows={5}
                        aria-label="With textarea"
                        name="formMessage"
                        value={formData.formMessage}
                        placeholder="Write the Message"
                        onChange={chnagehandler}
                      />
                    </Form.Group>
                  </div>

                  <div className="btn-div">
                    <button className="my-3 nav-Button px-4 py-3">
                      Send Message
                    </button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </Wrapper>
    </div>
  );
}

export default ContactUs;
